import { render, staticRenderFns } from "./SlideOut.vue?vue&type=template&id=f19ba9f0"
import script from "./SlideOut.vue?vue&type=script&lang=js"
export * from "./SlideOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvatarComponent: require('/Users/tdrdimov/gogoproj/fitapp - current GIT/fitnhealthy/src/components/AvatarComponent.vue').default})
